import React from "react";
import { sendToPrinter } from "../utils/api";

const TestSendToPrinter: React.FC = () => {
    const mockVendorId = 4; // Replace with an actual vendor ID
    let mockOrderId = 170; // Replace with an actual order ID

    const handleTestPrint = async () => {
        try {
            const response = await sendToPrinter(mockVendorId, mockOrderId, null, null); // Pass null for printEvent and printerLocation if not needed (defaults to "order_placed", "kitchen");
            if (response.success) {
                console.log("Print success:", response);
                alert("Receipt printed successfully!");
            } else {
                console.log("Print failed:", response);
                alert("Failed to print receipt.");
            }
        } catch (error) {
            console.error("Error during print test:", error);
            alert("An error occurred while printing the receipt.");
        }
    };

    
    return (
        <button
            onClick={handleTestPrint}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
            Test Send to Printer
        </button>
    );
};

export default TestSendToPrinter;
